
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M126 31h-10a2 2 0 00-2 2v19h-12.38a16.63 16.63 0 00-16.39 14H25a14.93 14.93 0 00-11 4.84V57a2 2 0 00-2-2H2a2 2 0 00-2 2v69a2 2 0 002 2h10a2 2 0 002-2v-24h100v24a2 2 0 002 2h10a2 2 0 002-2V33a2 2 0 00-2-2zm-24.38 25H114v23H89V68.62A12.63 12.63 0 01101.62 56zM25 70h60v9H14.18A11 11 0 0125 70zm-15 54H4V59h6v65zm4-26V83h100v15zm110 26h-6V35h6z"}}),_c('path',{attrs:{"d":"M68.75 44h-9.5A4.09 4.09 0 0155 40v-9h-9a4.09 4.09 0 01-4-4.25v-9.5A4.09 4.09 0 0146 13h9V4a4.09 4.09 0 014.25-4h9.5A4.09 4.09 0 0173 4v9h9a4.09 4.09 0 014 4.25v9.5A4.09 4.09 0 0182 31h-9v9a4.09 4.09 0 01-4.25 4zM59 40h9.72a.48.48 0 00.28-.08V29a2 2 0 012-2h11v-9.75a.48.48 0 00-.06-.25H71a2 2 0 01-2-2V4h-9.75a.48.48 0 00-.28.08L59 15a2 2 0 01-2 2H46v9.75a.48.48 0 00.08.28L57 27a2 2 0 012 2v11zm23-23z"}})])
          )
        }
      }
    